import React from 'react';
import { Target, Save, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const VisualWorkflowBuilder = () => {
  return (
    <div className="visual-workflow-builder" style={{ fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <Link 
            to="/workflow/management" 
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-4"
          >
            <ArrowLeft size={20} className="mr-2" />
            Back to Workflow Management
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Visual Workflow Builder</h1>
          <p className="text-gray-600 mt-2">
            Create custom workflows with our intuitive drag-and-drop interface.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="text-center py-12">
            <div className="bg-green-100 p-4 rounded-2xl w-fit mx-auto mb-6">
              <Target size={48} className="text-green-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Workflow Designer</h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Drag and drop workflow elements to create intelligent business processes. 
              This feature will be available in v2.0.
            </p>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="text-yellow-800 text-sm">
                <strong>Coming Soon:</strong> Visual workflow builder with drag-and-drop interface, 
                conditional logic, approval workflows, and automated task assignments.
              </p>
            </div>

            <button className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors flex items-center mx-auto">
              <Save size={20} className="mr-2" />
              Save Workflow
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisualWorkflowBuilder;
